import * as ChallengeQuestions from '../helpers/credentials/ChallengeQuestions';
import * as OobBio from '../helpers/credentials/OobBio';
import * as OobPhone from '../helpers/credentials/OobPhone';
import * as OobSms from '../helpers/credentials/OobSms';
import * as TrxSign from '../helpers/credentials/TrxSign';
import * as PushOtp from '../helpers/credentials/PushOtp';

import { IStoreState, ThunkDispatch } from '.';

import { Action } from 'redux';
import { RequestArgs } from './api';

// Types

export interface ChallengeState {
  analyzeRequest: RequestArgs
  analyzeResponse: any
  open: boolean
  challengeResolve: (result: ChallengeResult.Success | ChallengeResult.Failure | ChallengeResult.Error | ChallengeResult.None) => void
  challengeResult: ChallengeResult
  requiredCredentials: {
    challengeQuestions: boolean
    oobPhone: boolean
    oobSms: boolean
    trxSign: boolean
    pushOtp: boolean
  }
}

interface AuthMethodChallenge {
  required: boolean
}

export enum ChallengeResult {
  None,
  Pending,
  Success,
  Failure,
  Error,
}
// Initialization

const initialState: ChallengeState = {
  analyzeRequest: {},
  analyzeResponse: {},
  open: false,
  challengeResolve: (_) => { },
  challengeResult: ChallengeResult.None,
  requiredCredentials: {
    challengeQuestions: false,
    oobPhone: false,
    oobSms: false,
    trxSign: false,
    pushOtp: false,
  }
}

// Action Definition

export const CHALLENGE_OPEN = 'challenge/OPEN'
export const CHALLENGE_CLOSE = 'challenge/CLOSE'
export const CHALLENGE_ENROLLED = 'challenge/ENROLLED'

interface ChallengeOpenAction extends Action {
  type: typeof CHALLENGE_OPEN
  analyzeRequest: RequestArgs
  analyzeResponse: any
  challengeResolve: () => void
}

interface ChallengeCloseAction extends Action {
  type: typeof CHALLENGE_CLOSE,
  challengeResult: ChallengeResult,
}

// Reducer

export default (state: ChallengeState = initialState, action: Action) => {
  switch (action.type) {
    case CHALLENGE_OPEN:
      let openAction = (action as ChallengeOpenAction)
      let requiredCredentials = _.castArray(_.get(openAction.analyzeResponse, 'requiredCredentialList.requiredCredential', []))

      return {
        ...state,
        analyzeRequest: openAction.analyzeRequest,
        analyzeResponse: openAction.analyzeResponse,
        open: true,
        challengeResolve: openAction.challengeResolve,
        challengeResult: ChallengeResult.Pending,
        requiredCredentials: {
          challengeQuestions: ChallengeQuestions.isRequired(requiredCredentials),
          oobPhone: OobPhone.isRequired(requiredCredentials),
          oobSms: OobSms.isRequired(requiredCredentials),
          oobBio: OobBio.isRequired(requiredCredentials),
          pushOtp: PushOtp.isRequired(requiredCredentials),
          trxSign: TrxSign.isRequired(requiredCredentials)
        }
      }
    case CHALLENGE_CLOSE:
      return {
        ...state,
        open: false,
        challengeResult: (action as ChallengeCloseAction).challengeResult,
      }

    default:
      return state
  }
}

// Action Creators

export const openChallengeDialog = (request: RequestArgs, data: any, challengeResolve: (result: ChallengeResult) => void) =>
  (dispatch: ThunkDispatch) => {
    return dispatch({
      type: CHALLENGE_OPEN,
      analyzeRequest: request,
      analyzeResponse: data,
      challengeResolve
    } as ChallengeOpenAction);
  }

export const closeChallengeDialog = (result: ChallengeResult.Success | ChallengeResult.Failure | ChallengeResult.Error | ChallengeResult.None) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    getState().challenge.challengeResolve(result)

    return dispatch({
      type: CHALLENGE_CLOSE,
      challengeResult: result,
    } as ChallengeCloseAction)
  }